import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import commonLoadingAnimation from '@/shared/assets/lottie/common_loading_animation.json';

interface CommonLoadingAnimationProps {
  baseTime?: number;
  size?: string;
  text?: string | null;
  className?: string;
  fullPage?: boolean;
  blur?: boolean;
}

export default function CommonLoadingAnimation({
  baseTime = 0.2,
  size = '18rem',
  text = null,
  className,
  fullPage = false,
  blur = true,
}: CommonLoadingAnimationProps) {
  const [isToLong, setIsToLong] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsToLong(true);
    }, baseTime * 1000);

    return () => {
      setIsToLong(false);
    };
  }, [baseTime]);

  return isToLong ? (
    <S.LoadingContainer className={className} $fullPage={fullPage} $blur={blur}>
      <S.ContentWrapper>
        <div style={{ width: size, height: size, overflow: 'hidden' }}>
          <Lottie animationData={commonLoadingAnimation} style={{ width: size, height: size, transform: 'scale(2.5)' }} />
        </div>
        {text && <S.LoadingText className='common_loading_animation_text'>{text}</S.LoadingText>}
      </S.ContentWrapper>
    </S.LoadingContainer>
  ) : (
    <S.ShortLoading />
  );
}

const S = {
  LoadingContainer: styled.div<{ $fullPage: boolean; $blur: boolean }>`
    position: ${({ $fullPage }) => ($fullPage ? 'fixed' : 'absolute')};
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ $blur }) =>
      $blur &&
      css`
        background-color: rgba(0, 0, 0, 0.2);
        backdrop-filter: blur(1px);
      `}
  `,

  ContentWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,

  LoadingText: styled.p`
    font-size: 1.25rem;
    text-align: center;
    padding: 0.5rem 1.5rem;
    color: #333;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(1px);
    border-radius: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    white-space: pre-line;
  `,

  ShortLoading: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.01);
    filter: blur(0.6);
  `,
};
